import { ControlledPromise } from 'src/utils/controlled-promise';

export interface Executor<T> {
  (): Promise<T>;
  control: ControlledPromise<T>;
}

export const connectPromise = <T>(promise: Promise<T>, control: ControlledPromise<T>) =>
  promise.then(control.resolve).catch(control.reject);

export function createExecutor<T>(operation: () => Promise<T>): Executor<T> {
  const controledPromise = new ControlledPromise<T>();

  const executor: Executor<T> = () => {
    const promise = operation();
    connectPromise(promise, executor.control);
    return promise;
  };

  executor.control = controledPromise;

  return executor;
}
